export const barcelonaGaudiProgram = {
  programKey: 'barcelona-miasto-oczami-gaudiego',

  /* Podstawowe informacje wspólne dla sticky paska i katalogu. */
  title: 'Barcelona - Miasto oczami Gaudiego',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Barcelona:',
  stickySubtitle: 'Miasto oczami Gaudiego',

  pageUrl:
    'https://coolturystki.pl/wycieczki/barcelona-miasto-oczami-gaudiego',

  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/barcelona-sagrada-familia-z-lotu-ptaka-mth5cm06.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/barcelona-sagrada-familia-z-lotu-ptaka-mth5cm06.webp',
    imagePosition: 'center top',
    summary: '',
    destinations: ['Barcelona'],
    continent: 'Europa',
    categories: [],
    travelStyles: ['City break'],
    catalogPublishedAt: '2026-09-03',
  },

  /* Termin o ID 16: 18 - 21 lutego 2027. */
  tripIds: [16],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '16': {
      pilotId: 'rafal',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Wylot grupowy z Warszawy',
          description:
            'Wspólny lot odbywa się w obie strony między Lotniskiem Chopina w Warszawie a lotniskiem Barcelona-El Prat (BCN). Możliwy jest również bezpośredni wylot z Krakowa i dołączenie do grupy w Barcelonie.',
        },
        hotel: {
          title: 'Hotel 3★ w Sant Gervasi',
          description:
            'Zakwaterowanie znajduje się w spokojnej dzielnicy z dogodnym dojazdem do centrum. Czekają na nas pokoje 2-osobowe oraz śniadania.',
        },
      },
    },
  },
}
